<template>
  <a class="actions-btn">
    <img :src="icon" width="80" />
  </a>
</template>
<script>
export default {
  props: ["icon"],
};
</script>
